import { PhoneCall } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { api } from "@/api";

// Sessions d'appels en cours ou confiées par l'administrateur
export const MySessions = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/call-sessions").then(({ data }) => setRows(data.slice(0, 3))).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <section className="card cs-mine" data-testid="my-call-sessions">
      <h3><PhoneCall size={16} /> Mes sessions d'appels</h3>
      <ul>
        {rows.map((r) => (
          <li key={r.id}>
            <Link to={`/session-appels/${r.id}`} data-testid={`my-session-${r.id}`}>
              <strong>{r.label || "Session d'appels"}</strong>
              <small>{new Date(r.started_at).toLocaleDateString("fr-FR", { day: "numeric", month: "short" })} · {r.done} / {r.total} fiches{r.created_by_name ? ` · confiée par ${r.created_by_name}` : ""}{r.script_name ? ` · script « ${r.script_name} »` : ""}</small>
              <span>Reprendre</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
